<div id="favoriteY" #favoriteY class="favorite-article article" *ngIf="(fourFavoriteProducts | async).length !== 0">
  <div class="article-wrapper container-primary">
    <div class="title-block-slider-wrapper">
      <p (click)="openPrivatePageBlock(listLE.private, 'favorite')" class="title-block-slider-content">{{'favorite' |
        transloco}}</p>
      <span (click)="openPrivatePageBlock(listLE.private, 'favorite')" class="watch-all"
        [ngStyle]="{'display': (fourFavoriteProducts | async).length > 4 ? 'block' : ''}">{{'show_more' |
        transloco}}</span>
    </div>
    <div class="wrapper-slide">
      <bz-product class="product" *ngFor="let item of (fourFavoriteProducts | async); trackBy: trackById" [isHomePage]="true"
        [BzProduct]="item" [isBtnToMenu]="false">
      </bz-product>
    </div>
  </div>
</div>

<div id="viewedY" #viewedY class="viewed-article article" *ngIf="(fourViewedProducts | async).length !== 0">
  <div class="article-wrapper container-primary">
    <div class="title-block-slider-wrapper">
      <p (click)="openPrivatePageBlock(listLE.private, 'viewed')" class="title-block-slider-content">{{'viewed' |
        transloco}}
      </p>
      <span (click)="openPrivatePageBlock(listLE.private, 'viewed')" class="watch-all"
        [ngStyle]="{'display': (fourViewedProducts | async).length > 4 ? 'block' : ''}">{{'show_more' |
        transloco}}</span>
    </div>
    <div class="wrapper-slide">
      <bz-product style="background: white;" class="product" *ngFor="let item of (fourViewedProducts | async); trackBy: trackById"
        [isViewed]="true" [isHomePage]="true" [BzProduct]="item" [isBtnToMenu]="false"></bz-product>
    </div>
  </div>
</div>

<div *ngFor="let item of (allBloks | async).filter(filterSlide).sort(desktopSort)" class="article">
  <div class="article-wrapper container-primary" id="instruction-desktop">
    <div class="title-block-slider-wrapper">
      <p class="title-block-slider-content" [textContent]="item.category | transloco"></p>
      <bz-button *ngIf="item.global" [type]="'white'" [text]="item.global" [textColor]="colors.primary"
        [borderColor]="colors.primary" [size]="{w: 105, h: 35}" [radius]="['8px ', '8px ', '8px ', '8px']"
        [hover]="'invert'"></bz-button>
    </div>
    <div id="slideY" class="wrapper-slide" #slideY>
      <div class="first-row">
        <ng-container *ngFor="let elem of item.slides, let i = index">
          <app-info-block-start-page *ngIf="i < 3" [type]="item.type" [slide]="elem" [ws]="item.ws"
            [hs]="item.hs"></app-info-block-start-page>
        </ng-container>
      </div>
      <div class="second-row">
        <ng-container *ngFor="let elem of item.slides, let i = index">
          <app-info-block-start-page *ngIf="i > 2" [type]="item.type" [slide]="elem" [ws]="item.ws"
            [hs]="item.hs"></app-info-block-start-page>
        </ng-container>
      </div>
    </div>
  </div>
</div>
